module.exports = __webpack_public_path__ + "img/millfields_rd_b1.916073b9.jpg";